import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { SendButton } from './Button';
import blueWave from '../images/blue-wave.svg';
import successIcon from '../images/success.svg';
import errorIcon from '../images/error.svg';
import { priceRows, Mobile, Desktop } from './utils';
// import 'react-phone-number-input/style.css';
// import PhoneInput from 'react-phone-number-input';

const Wrap = styled.section`
    background-image: url(${blueWave});
    background-position: bottom 100px left;
    background-repeat: repeat-x;
    background-size: auto;
    position: relative;
    &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 20%;
        bottom: 0;
        left: 0;
        background: linear-gradient(
            180deg,
            #00aff0 76.55%,
            #00aff0 84.49%,
            #00aff0 92.76%
        );
    }
    @media screen and (max-width: 800px) {
        padding: 80px 20px 70px;
        background-position: bottom -190px left -34%;
        background-size: cover;
    }
`;

const Container = styled.div`
    padding: 85px;
    max-width: 1440px;
    margin: 0 auto;
    position: relative;
    @media screen and (max-width: 1024px) {
        padding: 40px;
    }
    @media screen and (max-width: 800px) {
        padding: 0;
    }
`;

const ContactFormContainer = styled.div`
    background: #efefef;
    border-radius: 15px;
    padding: 40px 25px;
    box-shadow: 10px 20px 60px rgba(0, 0, 0, 0.2);

    margin: 0 auto;
    max-width: 1100px;
    @media screen and (max-width: 800px) {
        margin: 0;
        padding: 20px 15px;
    }
`;

const ColumnWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    @media screen and (max-width: 600px) {
        flex-direction: column;
    }
`;

const Column = styled.div`
    margin: 0 15px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    order: 1;
    form {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    @media screen and (max-width: 600px) {
        margin: 0;
    }
`;
const Column2 = styled(Column)`
    order: 2;
    @media screen and (max-width: 600px) {
        order: 0;
        margin: 0 0 40px;
    }
`;

const Privacy = styled.p`
    // flex-basis: 100%;
    margin: 25px 15px 0;
    /* margin: auto 0 0; */
    color: #6c6c6c;
    font-size: 14px;
    line-height: 19px;
    order: 3;
    @media screen and (max-width: 800px) {
        margin: 30px 0 0;
        font-size: 12px;
    }
`;
const PrivacyLink = styled.a`
    text-decoration: underline;
    font-size: 14px;
    color: #6c6c6c;
    &:hover {
        text-decoration: underline;
        cursor: pointer;
        opacity: 0.8;
    }
    @media screen and (max-width: 800px) {
        font-size: 12px;
    }
`;

const InputStyled = styled.input`
    background: #ffffff;
    border-radius: 5px;
    height: 55px;
    padding: 0 26px;
    font-size: 18px;
    line-height: 25px;
    display: block;
    margin-bottom: 20px;
    border: 1px solid ${props => (props.error ? 'red' : 'transparent')};
    :focus {
        outline: none;
    }
    ::placeholder {
        color: black;
        opacity: 0.6;
    }
    @media screen and (max-width: 800px) {
        font-size: 14px;
        line-height: 19px;
        height: 50px;
        padding: 0 15px;
    }
`;
const SendInformWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: center;
    h2 {
        font-size: 44px;
        line-height: 54px;
        margin-bottom: 20px;
    }
    img {
        width: 194px;
        margin-bottom: 30px;
    }
    p {
        font-size: 18px;
    }
    @media screen and (max-width: 800px) {
        img {
            width: 100px;
        }
        h2 {
            font-size: 20px;
            line-height: 30px;
        }
        p {
            font-size: 14px;
        }
    }
`;

const InputErrorStyled = styled.span`
    color: red;
`;

const customCountrySelect = () => null;

export const SuccessInform = ({
    header = 'Заявка получена!',
    message = 'Мы свяжемся с вами по указанному телефону и согласуем время пробного урока.',
}) => {
    return (
        <SendInformWrap>
            <img src={successIcon} alt="" />
            <h2>{header}</h2>
            <p>{message}</p>
        </SendInformWrap>
    );
};
export const ErrorInform = ({
    header = 'Ой!',
    message = 'Что-то пошло не так. Попробуйте перезагрузить страницу и попробовать еще раз.',
}) => {
    return (
        <SendInformWrap>
            <img src={errorIcon} alt="" />
            <h2>{header}</h2>
            <p>{message}</p>
        </SendInformWrap>
    );
};

const LESSON_VALUES = priceRows.reduce((obj, { number, price }, i) => {
    const id = (i + 1).toString();
    obj[id] = {
        lessonsPerWeek: number / 4,
        number,
        monthlyPrice: price,
        lessonPrice: price / number,
        id,
    };
    return obj;
}, {});

const SignupForm = ({
    showSlider,
    defaultValues = {},
    promoCode,
    password,
    submitURL = '/api/auth/signup',
    email = true,
    onSuccess,
}) => {
    const [status, setStatus] = useState('none');
    const [fields, setFields] = useState(() => {
        const initialFields = [
            {
                name: 'firstName',
                label: 'Имя и фамилия',
                value: '',
                error: null,
            },
        ];

        if (email) {
            initialFields.push({
                name: 'email',
                label: 'Почта',
                value: '',
                error: null,
            });
        }

        if (password) {
            initialFields.push({
                name: 'password',
                label: 'Пароль',
                value: '',
                error: null,
            });
        }

        initialFields.push({
            name: 'phone',
            label: 'Телефон',
            value: '',
            error: null,
        });

        if (promoCode) {
            initialFields.push({
                name: 'promoCode',
                label: 'Промокод',
                value: '',
                error: null,
            });
        }

        return initialFields;
    });
    const [lessons, setLessons] = useState('2');

    useEffect(() => {
        if (status === 'submitting') {
            let check = true;

            const submit = async () => {
                const fieldsValues = {
                    lastName: '',
                    // skype: 'no-skype',
                    ...defaultValues,
                };

                for (const { name, value } of fields) {
                    fieldsValues[name] = value;
                }

                try {
                    const response = await fetch(submitURL, {
                        method: 'POST',
                        body: JSON.stringify(fieldsValues),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                    const responseBody = await response.json();

                    if (!check) {
                        return;
                    }

                    if (
                        response.status === 400 &&
                        responseBody &&
                        Array.isArray(responseBody.errors)
                    ) {
                        const { errors } = responseBody;
                        const validationErrors = {};
                        for (const error of errors) {
                            if (error.name === 'ValidationError') {
                                validationErrors[error.key] = error.message;
                            }

                            if (
                                error.name === 'UserError' &&
                                error.message === 'INVALID_PROMOCODE'
                            ) {
                                validationErrors.promoCode =
                                    'Неверный промокод';
                            }
                        }
                        setStatus('none');

                        setFields(prevState => {
                            return prevState.map(field => {
                                if (
                                    typeof validationErrors[field.name] ===
                                    'string'
                                ) {
                                    return {
                                        ...field,
                                        error: validationErrors[field.name],
                                    };
                                }
                                return field;
                            });
                        });
                    } else if (response.status === 200) {
                        setStatus('success');
                    } else {
                        throw new Error();
                    }
                } catch (error) {
                    if (check) {
                        setStatus('error');
                    }
                }
            };

            submit();

            return () => {
                check = false;
            };
        }
    }, [status, fields, submitURL]);

    useEffect(() => {
        try {
            const COOKIE_NAME = 'kespa-signup-query';
            const hasCookie = document.cookie
                .split(';')
                .some(item => item.trim().startsWith(`${COOKIE_NAME}=`));

            const search = window.location.search.slice(1);

            if (search !== '' && !hasCookie) {
                const date = new Date();
                date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
                const dateString = date.toGMTString();
                const cookieValue = `${COOKIE_NAME}=${encodeURIComponent(
                    search
                )}; path=/; expires=${dateString}`;

                document.cookie = cookieValue;
            }
        } catch (error) {
            console.error(error);
        }
    }, []);

    useEffect(() => {
        if (status === 'success') {
            try {
                window.dataLayer.push({
                    event: 'SubmitApplication',
                });
            } catch (error) {
                console.error(error);
            }
            if (onSuccess) {
                onSuccess();
            }
        }
    }, [status]);

    const onChange = useCallback(e => {
        const { value, name } = e.currentTarget;
        setFields(prevState => {
            return prevState.map(field => {
                if (field.name === name) {
                    return {
                        ...field,
                        error: null,
                        value,
                    };
                }

                return field;
            });
        });
    }, []);

    const onChangePhone = useCallback(value => {
        setFields(prevState => {
            return prevState.map(field => {
                if (field.name === 'phone') {
                    return {
                        ...field,
                        error: null,
                        value,
                    };
                }

                return field;
            });
        });
    });

    const onSubmit = useCallback(async e => {
        e.preventDefault();
        setStatus('submitting');
    }, []);

    if (status === 'success') {
        return <SuccessInform />;
    }

    if (status === 'error') {
        return <ErrorInform />;
    }

    const isSubmitting = status === 'submitting';

    return (
        <form onSubmit={onSubmit}>
            {fields.map(({ name, label, value, error }) => {
                const hasError = typeof error === 'string';
                return (
                    <React.Fragment key={name}>
                        {hasError && (
                            <InputErrorStyled>{error}</InputErrorStyled>
                        )}
                        <InputStyled
                            type={name === 'password' ? 'password' : undefined}
                            value={value}
                            error={hasError}
                            name={name}
                            onChange={onChange}
                            placeholder={label}
                            disabled={isSubmitting}
                        />
                    </React.Fragment>
                );
            })}
            {showSlider && (
                <SliderBlock
                    onChange={e => setLessons(e.target.value)}
                    value={lessons}
                />
            )}

            <SendButton as="button" disabled={isSubmitting}>
                {isSubmitting ? 'Отправка' : 'Записаться'}
            </SendButton>
        </form>
    );
};

const Slider = styled.input.attrs(props => {
    return {
        type: 'range',
    };
})`
    & {
        display: block;
        margin: 0.5em auto;
        padding: 0;
        background: transparent;
        font-size: 1em;
        cursor: pointer;
        width: 100%;
        position: relative;
    }
    &,
    &::-webkit-slider-runnable-track,
    &::-webkit-slider-thumb {
        -webkit-appearance: none;
    }
    /* // &:after {
    //     content: '';
    //     width: 1em;
    //     height: 1em;
    //     border-radius: 50%;
    //     background: #35aaf9;
    //     position: absolute;
    //     right: 0;
    // } */
    &:before {
        content: '';
        position: absolute;
        z-index: 0;
        left: 0.8em;
        right: 0.8em;
        height: 0.5em;
        background: white;
        box-sizing: border-box;
    }
    &::-ms-track {
        border: none;
        color: transparent;
    }
    &::-webkit-slider-thumb {
        border: none;
        border-radius: 50%;
        box-sizing: border-box;
        /* border: solid 0.35em transparent solid 0.25em transparent; */
        width: 2em;
        height: 2em;
        background: white;
        /* background-clip: content-box; */
        position: relative;
        z-index: 10;
        margin-top: -0.7em;
        box-shadow: 0 6px 15px #00000015;
        /* margin-left: 0.1em; */
    }
    &::-moz-range-thumb {
        border: none;
        border-radius: 50%;
        box-sizing: border-box;
        /* border: solid 0.35em transparent solid 0.25em transparent; */
        width: 2em;
        height: 2em;
        background: white;
        /* background-clip: content-box; */
        position: relative;
        z-index: 10;
        margin-top: -0.7em;
        box-shadow: 0 6px 15px #00000015;
        /* margin-left: 0.1em; */
    }
    &::-ms-thumb {
        border: none;
        border-radius: 50%;
        box-sizing: border-box;
        /* border: solid 0.35em transparent solid 0.25em transparent; */
        width: 2em;
        height: 2em;
        background: white;
        /* background-clip: content-box; */
        position: relative;
        z-index: 10;
        margin-top: -0.7em;
        box-shadow: 0 6px 15px #00000015;
        /* margin-left: 0.1em; */
    }
    &::-ms-tooltip {
        display: none;
    }
    &:focus {
        outline: none;
    }

    &:before {
        background-size: 50% 1em, 100% 0.25em;
    }
`;

const SliderBlock = ({ onChange, value }) => {
    return (
        <div
            style={{
                marginBottom: 20,
            }}
        >
            <div>Сколько раз в неделю вы планируете заниматься?</div>
            <div
                style={{
                    display: 'flex',
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: 15,
                    marginBottom: 15,
                }}
            >
                {Object.values(LESSON_VALUES)
                    .sort((a, b) => a.number - b.number)
                    .map(({ lessonsPerWeek, id }, i, arr) => {
                        const isFirst = i === 0;
                        const isLast = i === arr.length - 1;
                        const isActive = id === value;

                        return (
                            <div
                                key={lessonsPerWeek}
                                style={{
                                    opacity: isActive ? '1' : '0',
                                    fontSize: '1.4em',
                                    flex: 1,
                                    fontWeight: 700,
                                    fontFamily: 'Montserrat, sans-serif',
                                    // transition: '.1s ease 0s',
                                    textAlign: isFirst
                                        ? 'left'
                                        : isLast
                                        ? 'right'
                                        : 'center',
                                }}
                            >
                                {lessonsPerWeek}
                            </div>
                        );
                    })}
            </div>
            <div
                style={{
                    marginLeft: 0,
                    marginRight: 0,
                }}
            >
                <Slider
                    min="1"
                    max="3"
                    value={value}
                    step="1"
                    onChange={onChange}
                />
            </div>
            <div
                style={{
                    display: 'flex',
                }}
            >
                {Object.values(LESSON_VALUES)
                    .sort((a, b) => a.number - b.number)
                    .map(({ lessonPrice, monthlyPrice, id }, i, arr) => {
                        const isFirst = i === 0;
                        const isLast = i === arr.length - 1;
                        const isActive = id === value;
                        if (!isActive) {
                            return null;
                        }

                        return (
                            <div
                                key={id}
                                style={{
                                    opacity: isActive ? '1' : '0',
                                    width: isActive ? 'auto' : '0',
                                    height: isActive ? 'auto' : '0',
                                    fontSize: '1em',
                                    transition: '0.1s ease 0s',
                                    flex: 1,
                                    fontFamily: 'Montserrat, sans-serif',
                                    textAlign: isFirst
                                        ? 'left'
                                        : isLast
                                        ? 'right'
                                        : 'center',
                                }}
                            >
                                Урок: {lessonPrice}₽ <br />В месяц:{' '}
                                {monthlyPrice}₽
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export const FormSection = ({
    showSlider = true,
    rightColumn,
    defaultValues,
    submitURL,
    promoCode,
    password,
    email,
    onSuccess,
}) => {
    const privacy = (
        <Privacy>
            Нажимая, вы принимаете условия
            <br />
            <PrivacyLink target="_blank" href="https://kespa.ru/privacy">
                Соглашения на обработку персональных данных.
            </PrivacyLink>
        </Privacy>
    );

    return (
        <Wrap id="form">
            <Container>
                <ContactFormContainer>
                    <ColumnWrapper>
                        <Column>
                            <SignupForm
                                submitURL={submitURL}
                                defaultValues={defaultValues}
                                showSlider={showSlider}
                                promoCode={promoCode}
                                password={password}
                                email={email}
                                onSuccess={onSuccess}
                            />
                            {!showSlider && <Desktop>{privacy}</Desktop>}
                        </Column>
                        <Column2>
                            {rightColumn}
                            {showSlider && <Desktop>{privacy}</Desktop>}
                        </Column2>
                    </ColumnWrapper>
                    <Mobile>{privacy}</Mobile>
                </ContactFormContainer>
            </Container>
        </Wrap>
    );
};
